<script>
    // @ts-nocheck
    import { ScrollBox } from '../UI'
    import DatatableHeader from './DatatableHeader.svelte'
    import createDataStore from '../../stores/datastore'
    import { createEventDispatcher } from 'svelte'
    import { writable } from 'svelte/store'
    import { fade } from 'svelte/transition'
    import { range, capitalize, sortBy } from '$lib/utils'
    export let initialData = []
    export let waitingSignals = writable(0)
    export let data = createDataStore(initialData)
    export let style = ''
    export let schema = null
    export let currentPage = 1
    export let ordering = true
    export let pageSize = 15
    export let pagination = {}
    export let sortDirective = writable([])
    export let selectable = false
    export let selected = []
    export let unlockSelection = false
    export let maxSelectedRows = -1
    const dispatch = createEventDispatcher()

    function select(id, item = null, ctrl = false) {
        ctrl = ctrl || unlockSelection
        let tmpSelect = new Set(selected)
        let active = tmpSelect.has(id)
        let multi = tmpSelect.size > 1
        if (!ctrl) tmpSelect.clear()
        if ((active && !multi) || (ctrl && active)) {
            tmpSelect.delete(id)
        } else if (active) {
            tmpSelect.add(id)
        } else {
            tmpSelect.add(id)
        }
        selected = Array.from(tmpSelect)
        dispatch('select', { id, item })
    }

    function buildSchema() {
        if (schema === null) {
            // Esquema automatico
            schema = Object.fromEntries(
                Array.from(
                    $data.reduce((allKeys, item) => {
                        Object.keys(item).forEach(async (x) => {
                            await allKeys.add(x)
                        })
                        return allKeys
                    }, new Set())
                ).map((h) => [
                    h.toLowerCase(),
                    {
                        label: capitalize(h).replace(/_/g, ' '),
                        type: 'string',
                        virtual: false,
                        render: (x) => (x !== undefined ? x : '-'),
                        validation: (_) => true,
                        ordering: true,
                        props: {},
                    },
                ])
            )
        } else if (typeof schema === 'object') {
            // Normalizar esquema
            schema = Object.entries(schema)
                .map(([k, v]) => {
                    let tmp
                    if (typeof v === 'string') {
                        tmp = {
                            type: v,
                            virtual: false,
                            label: capitalize(k).replace(/_/g, ' '),
                            render: (x) => (x !== undefined ? x : '-'),
                            ordering: true,
                            props: {},
                        }
                    } else if (typeof v === 'object')
                        tmp = {
                            type: 'string',
                            virtual: false,
                            label: capitalize(k).replace(/_/g, ' '),
                            render: (x) => (x !== undefined ? x : '-'),
                            ordering: true,
                            props: {},
                            ...v,
                        }
                    return [k, tmp]
                })
                .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
        }
    }
    buildSchema()
    $: offset = (currentPage - 1) * pageSize
    $: limit = (currentPage - 1) * pageSize + pageSize
    $: total = $data instanceof Array ? $data.length : 0
    $: pagination = { offset, limit, total, currentPage, size: pageSize }
    $: if (Object.keys(schema).length == 0 && $data.length > 0) {
        schema = Object.fromEntries(Object.keys($data[0]).map((x) => [x, {}]))
        buildSchema()
    }
    $: if (maxSelectedRows >= 0 && selected.length > maxSelectedRows) {
        selected = selected.slice(-1 * maxSelectedRows)
    }
    $: console.log({$sortDirective})
</script>

{#if $data?.length > 0}
    <!-- <ScrollBox width="100%" height="auto"> -->
    <div class="container">
        <table
            class="datatable"
            in:fade={{ delay: 250 }}
            cellspacing="0"
            {style}
        >
            <thead>
                {#if !$$slots.header}
                    <DatatableHeader
                        {schema}
                        bind:sortDirective
                        {ordering}
                        endOfRow={!!$$slots.endOfRow}
                    />
                {:else}
                    <slot name="header" />
                {/if}
            </thead>
            <tbody>
                {#if [1, null, undefined].includes(currentPage) && $waitingSignals > 0}
                    {#each range($waitingSignals) as _}
                        <slot name="skeleton" />
                    {/each}
                {/if}
                {#each sortBy($data, $sortDirective, schema).slice(offset, limit + 1) || [] as item (item.id)}
                    {#if $$slots.row}
                        <slot name="row" {item} />
                    {:else}
                        <tr
                            class:selectable
                            class:active={selected.includes(item.id)}
                            on:click={(e) => {
                                if (selectable) select(item.id, item, e.ctrlKey)
                            }}
                        >
                            {#each Object.keys(schema) as column}
                                <td>
                                    {#if typeof schema[column].type == 'function'}
                                        {@const props =
                                            typeof schema[column].props ===
                                            'function'
                                                ? schema[column].props(
                                                      item[column],
                                                      item
                                                  )
                                                : schema[column].props}
                                        <svelte:component
                                            this={schema[column].type}
                                            {...props}
                                        >
                                            {#if typeof schema[column].render == 'function'}
                                                {@html schema[column].render(
                                                    item[column],
                                                    item
                                                )}
                                            {/if}
                                        </svelte:component>
                                    {:else}
                                        {@html schema[column].render(
                                            item[column],
                                            item
                                        )}
                                    {/if}
                                </td>
                            {/each}
                            {#if $$slots.endOfRow}
                                <td>
                                    <slot name="endOfRow" {item} />
                                </td>
                            {/if}
                        </tr>
                    {/if}
                {/each}
                <slot name="endOfRows"/>
            </tbody>
        </table>
    </div>
    <!-- </ScrollBox> -->
{:else}
    <span
        style="border-top: 1px #CCCCCC solid; gap: 20px;justify-content: center;align-items: center;display: flex; flex-direction: column; width: 100%; padding: 35px 0"
    >
        <slot name="noContent" />
    </span>
{/if}

<style>
    :root {
        --body-font-size: 14px;
        --header-height: 42px;
        --row-height: 72px;
        --accent-color-bg: var(--color-accent-notification-warning-bg);
        --accent-color: inherit;
        --oven-row-background: inherit;
        --odd-row-background: inherit;
        --background-freeze-cell: rgba(255, 255, 255, 1);
    }
    table {
        table-layout: revert;
        border-collapse: collapse;
    }
    table,
    thead,
    tbody {
        width: 100%;
        background: #ffffff;
    }
    tbody td {
        font-size: var(--body-font-size)
    }
    table :global(td) {
        padding: 0 calc((24 / 42) * var(--row-height)); /*24px;*/
    }
    table thead :global(tr) {
        height: var(--header-height);
        background: var(--color-grey-150);
        user-select: none;
    }
    table tbody :global(tr) {
        height: var(--row-height);
        border-bottom: 1px solid var(--color-grey-300);
    }
    tr {
        transition: background 10ms ease-in-out;
    }
    tr.active,
    tr.active:hover {
        color: var(--accent-color);
        background: var(--accent-color-bg);
    }
    .selectable {
        cursor: pointer;
    }
    .selectable:hover {
        background: rgba(0, 0, 0, 0.03);
    }
    :global(.datatable thead tr:first-child) {
        position: sticky;
        top: 0;
        z-index: 4;
    }
    :global(.datatable td:first-child) {
        position: sticky;
        z-index: 3;
        left: 0;
    }
    :global(.datatable td:last-child) {
        position: sticky;
        z-index: 3;
        right: 0;
    }
    :global(.datatable tbody td:first-child) {
        /* background: rgb(255, 255, 255); */
        /* border-bottom: 1px var(--color-grey-300) solid; */
        background: linear-gradient(
            90deg,
            var(--background-freeze-cell) 0%,
            var(--background-freeze-cell) 95%,
            rgba(255, 255, 255, 0) 100%
        );
    }
    :global(.datatable tbody td:last-child) {
        /* background: rgb(255, 255, 255); */
        /* border-bottom: 1px var(--color-grey-300) solid; */
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            var(--background-freeze-cell) 13%,
            var(--background-freeze-cell) 100%
        );
    }
    :global(.datatable thead td:first-child, .datatable thead td:last-child) {
        background-color: #ebebeb;
    }

    :global(.datatable tbody tr:nth-child(odd)) {
        background-color: var(--odd-row-background);
        position: relative;
        /* font-weight: 900; */
    }

    :global(.datatable tbody tr:nth-child(even)) {
        background-color: var(--even-row-background);
        position: relative;
        /* font-weight: 900; */
    }
    .container {
        width: 100%;
        height: auto;
        position: relative;
        overflow-x: auto;
        box-sizing: border-box;
        /* -ms-overflow-style: none;
        scrollbar-width: none; */
    }
</style>
